import React, { useEffect, useMemo } from 'react';

import cx from 'classnames';
import { useFlexLayout, useSortBy, useTable } from 'react-table';

import Blocker from './Blocker';
import ColumnHeaderCell from './ColumnHeaderCell';
import s from './index.module.css';
import RowOptions from './RowOptions';

const headerProps = (props, { column }) => getStyles(props, { ...(column.customProps || {}), alignItems: 'center' });

const cellProps = (props, { cell }) => getStyles(props, { ...(cell.column.customProps || {}) });

const getStyles = (props, { align = 'left', fixedWidth = false, alignItems = 'flex-start' }) => {
  const style = {
    style: {
      justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
      display: 'flex',
      alignItems,
    },
  };
  if (fixedWidth) {
    style.style.flexGrow = 0;
  }

  return [props, style];
};

function TableDiv({
  columns,
  data,
  tableClassName,
  manualSortBy = true,
  disableSortBy = false,
  getRowOptions,
  tableBodyClassName,
  tableHeadClassName,
  onChangeSort = () => {},
  withBlocker,
  initialState,
}) {
  const memoizedData = useMemo(() => data, [data]);
  const memoizedColumns = useMemo(() => columns, [columns]);

  const {
    getTableProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns: memoizedColumns,
      data: memoizedData,
      manualSortBy,
      disableSortBy,
      initialState,
    },
    useFlexLayout,
    useSortBy,
  );

  useEffect(() => {
    onChangeSort(sortBy);
  }, [onChangeSort, sortBy]);

  return (
    <div {...getTableProps()} className={cx(s.table, tableClassName)}>
      <div className={cx(s.thead, tableHeadClassName)}>
        {headerGroups.map((headerGroup) => (
          <div key={headerGroup.key} {...headerGroup.getHeaderGroupProps()} className={s.tr}>
            {headerGroup.headers.map((column) => (
              <div
                key={column.key}
                {...column.getHeaderProps(column.getSortByToggleProps(headerProps))}
                className={s.th}
              >
                <ColumnHeaderCell column={column} />
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className={cx(s.tbody, tableBodyClassName)}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <div key={row.key} {...row.getRowProps()} className={s.tr}>
              {row.cells.map((cell, i) => {
                return (
                  <div
                    key={cell.key}
                    {...cell.getCellProps(cellProps)}
                    className={cx(s.td, i === row.cells.length - 1 && s.lastTd)}
                  >
                    {cell.render('Cell')}
                  </div>
                );
              })}
              {getRowOptions && <RowOptions options={getRowOptions(row)} />}
            </div>
          );
        })}
        {withBlocker && <Blocker text={withBlocker?.placeholder} />}
      </div>
    </div>
  );
}

export default TableDiv;
